import {
  ListResponseModel,
  PermissionGroupDetailModel,
  PermissionGroupModel,
  PermissionGroupNotificationInputModel,
  PermissionGroupScopeInputModel,
  QueryParamModel,
} from 'models';
import request, { Methods } from 'utils/request';
import { EntityService } from 'utils/entityService';

export interface CreatePermissionGroupPayload {
  name: string;
  scopes: PermissionGroupScopeInputModel[];
  notifications: PermissionGroupNotificationInputModel[];
}

export interface UpdatePermissionGroupPayload extends CreatePermissionGroupPayload {
  isActive: boolean;
}

export interface UpdatePermissionGroupMembersPayload {
  userIds: number[];
}

class PermissionGroupService extends EntityService {
  constructor() {
    super('permission-groups');
  }

  async getPermissionGroupList(params?: QueryParamModel | null) {
    return request<ListResponseModel<PermissionGroupModel>>({
      method: Methods.GET,
      resource: this.resource,
      params,
    });
  }

  async getPermissionGroupListSearch() {
    return request<PermissionGroupModel[]>({
      method: Methods.GET,
      resource: `${this.resource}/search`,
    });
  }

  async getPermissionGroup(id: ID) {
    return request<PermissionGroupDetailModel>({
      method: Methods.GET,
      resource: `${this.resource}/${id}`,
    });
  }

  async createPermissionGroup(data: CreatePermissionGroupPayload) {
    return request<PermissionGroupModel>({
      method: Methods.POST,
      resource: this.resource,
      data,
    });
  }

  async updatePermissionGroup(id: ID, data: UpdatePermissionGroupPayload) {
    return request<PermissionGroupModel>({
      method: Methods.PATCH,
      resource: `${this.resource}/${id}`,
      data,
    });
  }

  async updatePermissionGroupMembers(id: ID, data: UpdatePermissionGroupMembersPayload) {
    return request<void>({
      method: Methods.PATCH,
      resource: `${this.resource}/${id}/members`,
      data,
    });
  }
}

export const permissionGroupService = new PermissionGroupService();
